<template>
  <div class="thermique__evs">
    <a :href="ev.link">
      <div v-html="ev.img"></div>
    </a>
    <div v-html="`${description} ${linkToProduct}`"></div>
  </div>
</template>

<script>

export default {
  name: "EV",
  props: {
    ev: {
      type: Object,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    linkToProduct() {
      return `<a href="${this.ev.link}">Voir ce produit &#8594;</a>`
    },
  },
}
</script>

<style scoped lang="scss">
.thermique__evs {
  display: grid;
  grid-row-gap: 1rem;
  margin-bottom: 3rem;
  a {
    justify-self: center;
  }
}
@media screen and (min-width: 768px) {
  .thermique__evs {
    grid-template-columns: 200px auto;
  }
}
</style>
